import React, { useState } from "react";

const ContentTab = ({ handleLayoutChange, selectedLayout,updateAgeVerificationTabData,ageVerificationTabData }) => {
    const [message, setMessage] = useState(ageVerificationTabData.message);
    const [caption, setCaption] = useState(ageVerificationTabData.caption);
    const [submitButtonText, setSubmitButtonText] = useState(ageVerificationTabData.submit_button_text);
    const [yesButtonText, setYesButtonText] = useState(ageVerificationTabData.yes_button_text);
    const [noButtonText, setNoButtonText] = useState(ageVerificationTabData.no_button_text);
    const [additionalInfo, setAdditionalInfo] = useState(ageVerificationTabData.additional_info);

    //Handlers Message Change
    const handleMessageChange = (event) => {
        const value = event.target.value;
        setMessage(value);
        updateAgeVerificationTabData("message", value);
    };

    //Handlers Caption Change
    const handleCaptionChange = (event) => {
        const value = event.target.value;
        setCaption(value);
        updateAgeVerificationTabData("caption", value);
    };

    //Handlers Submit Button Text Change
    const handleSubmitButtonTextChange = (event) => {
        const value = event.target.value;
        setSubmitButtonText(value);
        updateAgeVerificationTabData("submit_button_text", value);
    };

    //Handlers Yes Button Text Change
    const handleYesButtonTextChange = (event) => {
        const value = event.target.value;
        setYesButtonText(value);
        updateAgeVerificationTabData("yes_button_text", value);
    };

    //Handlers No Button Text Change
    const handleNoButtonTextChange = (event) => {
        const value = event.target.value;
        setNoButtonText(value);
        updateAgeVerificationTabData("no_button_text", value);
    };

    //Handlers Additional Info Change
    const handleAdditionalInfoChange = (event) => {
        const value = event.target.value;
        setAdditionalInfo(value);
        updateAgeVerificationTabData("additional_info", value);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <>
                <span>Content</span>
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <label>Message</label>
                        <input type="text" value={message} onChange={handleMessageChange} placeholder="Type Message..." />
                    </div>
                    <div className="box-header-row bubble-text">
                        <label className="mb-1"> Caption</label>
                        <textarea className="w-100" value={caption} onChange={handleCaptionChange} placeholder="Type Caption..." defaultValue=""></textarea>
                    </div>
                </div>
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <label>Submit Button Text</label>
                        <input type="text" value={submitButtonText} onChange={handleSubmitButtonTextChange} placeholder="" />
                    </div>
                </div>
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <label>Yes Button Text</label>
                        <input type="text" value={yesButtonText} onChange={handleYesButtonTextChange} />
                    </div>
                    <div className="box-header-row bubble-text">
                        <label>No Button Text</label>
                        <input type="text" value={noButtonText} onChange={handleNoButtonTextChange} />
                    </div>
                </div>
                <div className="side-baar-box-header">
                    <div className="box-header-row bubble-text">
                        <label className="mb-1">Additional Info</label>
                        <textarea className="w-100" value={additionalInfo} onChange={handleAdditionalInfoChange} placeholder="Type Additional Info..." defaultValue=""></textarea>
                    </div>
                </div>
            </>
        </div>
    );
};

export default ContentTab;